import { useMultiDialog } from '@/components/multiDialogsProvider'
import { markRaw, ref } from 'vue'
import { TeamTemplate } from '@/components/multiDialogsContent/createGroup'
import ConfigMembers from '@/components/multiDialogs/configMembers/index.vue'
import { RoleType } from '@/components/multiDialogs/type'
export const useCreateTeamDialog = () => {
  const commonDialog = useMultiDialog()
  const templateId = ref<number>()
  const groupId = ref<number>()
  const roleList = ref<RoleType[]>()
  // 显示创建空间时的选择模板弹窗
  const showTemplateDialog = () =>
    new Promise(() => {
      commonDialog.show({
        name: 'common',
        componentKey: 'teamTemplate',
        componentProps: {
          size: 'auto',
          footer: false,
          header: false,
          className: 'team-template-dialog',
          dialogContent: markRaw(TeamTemplate),
          dialogContentProps: {
            onCancel: () => {
              commonDialog.close()
            },
            onOk: async (Id?: number) => {
              templateId.value = Id
              await showInputInfoDialog()
            }
          }
        }
      })
    })

  // 打开填写团队名称和介绍弹框
  const showInputInfoDialog = () =>
    new Promise(() => {
      commonDialog.show({
        name: 'configForm',
        componentKey: 'InputTeamInfo',
        hideMask: false,
        maskClosable: true,
        isNested: true,
        componentProps: {
          templateId: templateId.value,
          onOk: async (Id: number, roleArray: RoleType[]) => {
            groupId.value = Id
            roleList.value = roleArray
            await showAddMember()
          }
        }
      })
    })

  // 打开添加成员管理员弹框
  const showAddMember = () =>
    new Promise(() => {
      commonDialog.show({
        component: ConfigMembers,
        componentKey: 'ConfigMembers',
        componentProps: {
          groupId: groupId.value,
          roleList: roleList.value,
          closeAll: () => {
            commonDialog.closeAll()
          }
        }
      })
    })

  const start = async () => {
    await showTemplateDialog()
  }

  return start
}
